import { Button} from '@material-tailwind/react';
const TabError = () => {
    
    return (
        <>
            <div className="h-screen flex items-center justify-center flex-col" style={{marginLeft: "10%", marginRight: "10%"}}>
                <h1>Important Notice: Data Integrity and Security</h1>
                <p>We have detected an issue with your current session, which has now expired.</p>

                <p>As the integrity of your data is vitally important to us, the system requires that each book be uploaded in a separate, dedicated session.</p>
                <br />
                <h1>Required Action: </h1>
                {/* <p>Please close this Tab and continue your process in the newly opened Tab.</p> */}
                <p>Please close all other tabs and log back in</p>
                <Button
                    color="red"
                    className="hover:bg-red hover:text-white hover:bg-red float-left mt-3 mb-3 md:mb-auto md:w-1/4"
                    buttonType="outline"
                    size="lg"
                    ripple="dark"
                    onClick={() => {window.location.href = "/login";}}
                >
                    Login         
                </Button>
            </div>
        </>
    );
};

export default TabError;
